import { defaultSelectMenuProps } from "./formControls";
import {
	captchaDisplayBackground,
	captchaDisplayBorder,
	captchaDisplayBorderWidth,
	captchaDisplayRadius,
} from "./tokens";

/** Auth form layout + typography — aligned with institute portal (employer brand colors). */

/** Menu paper class for auth select dropdowns (portaled — set on MenuProps.PaperProps). */
export const authSelectMenuPaperClassName = "auth-select-menu";

export const authSelectMenuProps = {
	...defaultSelectMenuProps,
	PaperProps: {
		...defaultSelectMenuProps.PaperProps,
		className: authSelectMenuPaperClassName,
	},
};

export const authPageHeadingClassName =
	"auth-page-heading font-['Poppins'] text-4xl font-semibold tracking-tight text-auth-heading short:text-[1.625rem] short:leading-tight";

export const authCardHeadingBandClassName =
	"mb-5 rounded-lg bg-gradient-to-b from-[rgb(254,254,254)] to-[rgb(250,250,250)] px-3 pb-4 pt-4 text-center short:mb-2 short:px-2 short:pb-2 short:pt-2";

export const authCardHeadingSubtextClassName =
	"auth-card-subtext mt-[8px] text-[14px] text-[#494949] short:text-[14px]";

/** Field labels — semibold, matches institute sizing. */
export const authFieldLabelClassName = "text-sm font-semibold sm:text-base";

export const authFormStackClassName = "space-y-3 short:space-y-1.5";

export const authFormStackLooseClassName = "space-y-4 short:space-y-2";

export const authFormGridGapClassName = "gap-3 short:gap-2";

/** Horizontal inset for signup sections + footer actions (matches `p-3` on field groups). */
export const authFormSectionInsetClassName = "px-3";

/** Submit button spacing — 20px top on all auth pages (enforced in CSS; space-y overrides plain margins). */
export const authSubmitButtonMarginClassName = "auth-submit-button !mt-[20px] !mb-4";

/** 44px / 40px — px heights; slightly below 48px fields, unaffected by :root 80% font-size. */
export const authSubmitButtonClassName =
	`${authSubmitButtonMarginClassName} min-h-[44px] h-[44px] !py-0 w-full !rounded-[10px] !font-['Poppins'] !text-base !font-semibold !leading-normal !tracking-normal text-white shadow-sm hover:shadow-md !border-0 bg-[var(--tvet-primary,#2a9699)] hover:!bg-[var(--tvet-primary-hover,#248a8c)] short:min-h-[40px] short:h-[40px] short:!text-sm`;

export const authRootErrorClassName =
	"mb-6 rounded-lg border border-red-200 bg-red-50 p-4 short:mb-2 short:p-2.5";

/** Wrap forms — shared field typography in index.css + compact heights on short screens. */
export const authFormCompactClassName = "auth-form-compact";

export const authLinkRowClassName =
	"auth-link-row !mt-[20px] !mb-[20px] flex flex-wrap items-center justify-between gap-3 text-sm text-gray-700";

export const authOtpFieldLabelClassName =
	"block text-center text-sm font-semibold text-gray-700 short:text-xs";

/** Captcha code display container (shared Login + Signup). */
export const captchaDisplayClassName =
	"flex items-center justify-center px-3 sm:min-h-[3.25rem] short:min-h-[2.5rem] short:px-2 [&_canvas]:block [&_canvas]:max-h-[2.75rem] [&_canvas]:w-auto short:[&_canvas]:max-h-[2.25rem]";

export const captchaDisplayStyle = {
	borderRadius: captchaDisplayRadius,
	border: `${captchaDisplayBorderWidth}px solid ${captchaDisplayBorder}`,
	background: captchaDisplayBackground,
} as const;

/** Refresh button beside captcha — matches field border. */
export const captchaRefreshButtonClassName =
	"inline-flex w-auto max-w-full shrink-0 items-center justify-center gap-1 rounded-lg border-[1.2px] border-[#D9D9D9] bg-white px-3 text-base font-medium text-gray-800 shadow-sm transition-colors hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50 sm:min-h-[3.25rem] short:min-h-[2.5rem] short:px-2 short:text-sm";

export const authCaptchaLabelClassName =
	"mb-2 block text-sm font-semibold text-gray-900 short:mb-1 short:text-xs";

export const authCaptchaInputWrapClassName = "mt-2 short:mt-1";

/** Employer captcha text color (single tone, aligned with institute behavior). */
export const captchaTextColor = "#2a9699";
